import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const FEATURE_DEFAULTS = {
  chat: true,
  sumup: true,
  recensioni: true,
  whatsapp: true,
  galleria: true,
  shop: true,
  promo: true,
  diretta: true,
};

// Interruptores de funciones visibles: el dueño los controla desde /admin ("Funzioni dell'app").
export default function useFeatures() {
  const [features, setFeatures] = useState(FEATURE_DEFAULTS);
  useEffect(() => {
    fetch(`${BACKEND}/api/features`)
      .then((r) => r.json())
      .then((d) => setFeatures({ ...FEATURE_DEFAULTS, ...(d || {}) }))
      .catch(() => {});
  }, []);
  return features;
}
